import { Profile } from '~/helpers/userProfile';
import {
  TContainer, Row, HeaderTitle, TableBody, THeader, TableHead, TableWrapper,
} from './styles';
import { HealthHistoryRow } from './healthHistorytableRow';

export interface HealthHistItem {
    devId: string,
    assetId: number
    date: string
    DAT_REPORT: number
    healthIndex: string
    H_INDEX: number
    possCauses: string[]
    UNIT_ID: number
    desc: string
    changeType: string
}

interface HealthHistoryTableProps {
  data: HealthHistItem[];
  profile: Profile;
  t: (key: string) => string;
  onDelete: (item: HealthHistItem) => void;
}

export function HealthHistoryTable({
  data, profile, t, onDelete,
}: Readonly<HealthHistoryTableProps>): JSX.Element {
  return (
    <TableWrapper>
      <TContainer>
        <TableHead>
          <Row>
            <THeader><HeaderTitle><span>&nbsp;</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>{t('descricao')}</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>{t('data')}</span></HeaderTitle></THeader>
            <THeader><HeaderTitle><span>{t('causas')}</span></HeaderTitle></THeader>
            {profile.manageAllClients && (
              <THeader><HeaderTitle><span>{t('tipoDeMudanca')}</span></HeaderTitle></THeader>
            )}
            {profile.permissions.HEALTH_MANAGEMENT && (
              <THeader><HeaderTitle><span>&nbsp;</span></HeaderTitle></THeader>
            )}
          </Row>
        </TableHead>

        <TableBody>
          {data.map((item) => (
            <HealthHistoryRow
              key={item.date} // de preferência use um id único
              item={item}
              profile={profile}
              onDelete={onDelete}
            />
          ))}
        </TableBody>
      </TContainer>
    </TableWrapper>
  );
}
